export enum InvestorType {
  Individual = 'Individual',
  Institution = 'Institution',
}
